module.exports = __webpack_public_path__ + "6a6e4b84a85e1229329525b9bb27fd53.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/Rist/content/tourWorks/room3/audio5/03_5MCA Im Not The Girl Who Misses Much.mp3
// module id = 780
// module chunks = 0